<template>
    <FormulateInput 
        v-if="loadJs && qrCodeStyling && personalizedType !== 'clipartCategory'" 
        :name="layer.id" :layer="layer" type="imageqr"
        :aspectRatio="aspectRatio" 
      />
</template>

<script>
import { get } from 'lodash'

export default {
  name: 'ImageQRField',
  data(){
    return {
      loadJs: false,
      qrCodeStyling: false
    }
  },
  props: {
    layer: {
      type: Object,
      required: true
    },
    artwork: {
      type: Object,
      required: true
    },
    personalized: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    personalizedType() {
      return this.layer.personalized.type
    },
    required() {
      return get(this.layer, 'personalized.required', false)
    },
    label() {
      return get(this.layer, 'personalized.label', this.layer.title)
    },
    aspectRatio() {
      const { layer } = this
      return layer.width / layer.height
    }
  },
  mounted(){
    const THIS = this;
    const createJs = document.createElement('script');
    createJs.src = 'https://unpkg.com/qr-border-plugin@0.1.1/build/index.js';
    createJs.onload = () => {
      THIS.loadJs = true;
    }

    const createqrCodeStylingJs = document.createElement('script');
    createqrCodeStylingJs.src = 'https://unpkg.com/qr-code-styling@1.9.2/lib/qr-code-styling.js';
    createqrCodeStylingJs.onload = () => {
      THIS.qrCodeStyling = true;
    }
    document.body.appendChild(createJs);
    document.body.appendChild(createqrCodeStylingJs);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Form/ImageQRField.vue